<div class="common-form-input">
    <div class="label" *ngIf="label">{{ label }}</div>
    <ng-content select="select"></ng-content>
    <div class="suffix">
        <ng-content select="[suffix]"></ng-content>
    </div>
    <div class="field-error" *ngIf="error && error.errors && error.touched">{{ getError }}</div>
</div>